export enum UserGatedAction {
    ADP_BID = 'ADP_BID',
    MAKE_OFFER = 'MAKE_OFFER',
    SDP_APPROVE = 'SDP_APPROVE',
    ADD_FAVORITE_ASSET = 'ADD_FAVORITE_ASSET',
}

type UserGatedActionState = Ref<
    | { action: Exclude<UserGatedAction, UserGatedAction.ADD_FAVORITE_ASSET>; payload?: never }
    | { action: UserGatedAction.ADD_FAVORITE_ASSET; payload: { assetId: string } }
    | null
>;

export const useUserGatedActionState = (): UserGatedActionState => useState('userGatedAction', () => null);
